import { Mail, Phone } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useModalContext } from '../../provider/ModalProvider';

const HelpModal: React.FC = () => {
  const theme = useTheme();
  const { setIsModalShown } = useModalContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        width: '100%',
      }}
    >
      {/* Title */}
      <Typography variant="h4" sx={{ marginBottom: '1rem' }}>
        <FormattedMessage id="HelpModal.title" defaultMessage="Hilfe" />
      </Typography>

      {/* Contact Information */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
          width: '100%',
        }}
      >
        {/* Email */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Mail sx={{ color: theme.palette.text.secondary }} />
          <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
            support@immersight.de
          </Typography>
        </Box>

        {/* Phone */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Phone sx={{ color: theme.palette.text.secondary }} />
          <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
            +49 731 280657433
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HelpModal;
